module.exports = __webpack_public_path__ + "static/media/resultats_sapin2020.e08a8419.jpg";